import { Injectable } from '@angular/core';

import Dexie from 'dexie';

@Injectable({
    providedIn: 'root',
})
export class CommonIndexDBService {
    private databases: Map<string, Dexie> = new Map();
    version: number = 2;

    createConnection(dbName: string, schema: { [table: string]: string }): Dexie {
        if (this.databases.has(dbName)) {
            return this.databases.get(dbName)!;
        }
        const db = new Dexie(dbName);
        db.version(this.version).stores(schema);

        this.databases.set(dbName, db);
        return db;
    }

    getDatabase(dbName: string): Dexie | undefined {
        return this.databases.get(dbName);
    }

    async clearAllTablesRecordsForCurrentIdentifierKey(
        dbName: string,
        lobbyType: string,
        dataIdentifierKey: string,
        collectionKey: string,
    ): Promise<void> {
        const db = this.getDatabase(dbName);
        if (!db) {
            return;
        }

        const tableNames = db.tables.map((table) => table.name);

        for (const tableName of tableNames) {
            const table = db.table(tableName);

            const records = await table.where('collectionKey').equals(collectionKey).toArray();

            const keysToDelete = records.map((record) => record.id);

            await table.bulkDelete(keysToDelete);
        }
    }
}
